<!--
 * @Author: zdx 3539255028@qq.com
 * @Date: 2022-06-17 13:23:51
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-05 18:12:54
 * @FilePath: \jeecg-boot\ant-design-vue-jeecg\src\views\modules\dataBoard\export.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <a-modal title="导出" okText="导出" centered :visible="visible" @ok="exportFunc" @cancel="$emit('close')">
    <div class="range">
      <span>导出范围</span>
      <a-range-picker v-model="timeRange" :style="{ width: '224px', marginLeft: '16px' }"></a-range-picker>
    </div>
  </a-modal>
</template>
<script>
import moment from 'moment'
import { OssService } from '@/utils/oss/oss_service'
import { exportKanBan, doMistServerUrl } from '@/api/api'
import { downloadExcel } from '@/api/manage'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    relTenantId: {
      type: String,
      default: ''
    },
    user: {
      type: Object,
      default: function() {
        return {}
      }
    },
    userLogin: {
      type: Object,
      default: function() {
        return {}
      }
    },
    solution: {
      type: Object,
      default: function() {
        return {}
      }
    },
    rpsDownload: {
      type: Object,
      default: function() {
        return {}
      }
    },
    rpsTimeType: {
      type: String,
      default: 'day'
    },
    userLoginTimeType: {
      type: String,
      default: 'day'
    },
    userTimeType: {
      type: String,
      default: 'day'
    },
    rpsOrSolution: {
      type: String,
      default: 'rps'
    }
  },
  data() {
    return {
      timeRange: []
    }
  },
  methods: {
    async exportFunc() {
      const params = {
        endTime: this.timeRange[1] ? moment(this.timeRange[1]).format('yyy/MM/DD') : undefined,
        startTime: this.timeRange[0] ? moment(this.timeRange[0]).format('yyy/MM/DD') : undefined,
        rpsCreateBy: this.rpsDownload.rpsCreateBy,
        rpsDownloadEndTime: moment(this.rpsDownload.rpsDownloadEndTime).format('yyy/MM/DD'),
        rpsDownloadStartTime: moment(this.rpsDownload.rpsDownloadStartTime).format('yyy/MM/DD'),
        rpsOrSolution: this.rpsOrSolution,
        rpsTimeType: this.rpsTimeType,
        userEndTime: moment(this.user.userEndTime).format('yyy/MM/DD'),
        userLoginEndTime: moment(this.userLogin.userLoginEndTime).format('yyy/MM/DD'),
        userLoginStartTime: moment(this.userLogin.userLoginStartTime).format('yyy/MM/DD'),
        userLoginTimeType: this.userLoginTimeType,
        userStartTime: moment(this.user.userStartTime).format('yyy/MM/DD'),
        userTimeType: this.userTimeType
      }

      await downloadExcel(`${doMistServerUrl}/kanban/oss/exportKanBan`, '运营数据', params)
      this.$emit('close')
    }
  }
}
</script>
<style lang="less">
.range {
  text-align: center;
}
.ant-btn-primary {
  background-color: #0593e9;
}
</style>
